@if (isSheet) {
  <ui-dialog-layout
    [title]="'INACTIVITY.TITLE' | translate"
    [dismissible]="false"
  >
    <div uiDialogBody class="inactivity-sheet-body">
      {{ 'INACTIVITY.DESCRIPTION' | translate: { seconds: secondsLeft } }}
    </div>
    <ui-button
      uiDialogFooter
      class="w-100"
      type="primary"
      size="l"
      [text]="'COMMON.YES' | translate"
      (clickAction)="close()"
    ></ui-button>
  </ui-dialog-layout>
} @else {
  <div class="flex-col inactivity-modal">
    <div>
      <span class="icon ui-icon-time"></span>
    </div>
    <div class="title">{{ 'INACTIVITY.TITLE' | translate }}</div>
    <div class="description">
      {{ 'INACTIVITY.DESCRIPTION' | translate: { seconds: secondsLeft } }}
    </div>
    <button mat-flat-button color="primary" (click)="close()">
      {{ 'COMMON.YES' | translate }}
    </button>
  </div>
}
